<template>
  <div>
    <a-tabs type="card">
      <a-tab-pane key="1" :tab="tabName"> </a-tab-pane>
    </a-tabs>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAdd">新增</a-button>
      </div>
      <div>
        <a-button type="primary" icon="undo" style="margin-right: 10px" @click="search">{{ label }}</a-button>
        <a-button type="primary" icon="undo" ghost @click="handleClear">同步XML</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table row-key="id" :columns="columnsArticle" :loading="loading" :data-source="data" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <template slot="change_freq" slot-scope="text">
        {{ labelList(text) }}
      </template>

      <template slot="category" slot-scope="text">
        {{ categoryText(text) }}
      </template>

      <template slot="operator" slot-scope="text, record">
        <div class="flex-c-ac">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" style="margin-left: 20px" @click="del(record)">删除</a-button>
        </div>
      </template>
    </a-table>

    <!-- 添加公司 -->
    <AddArticle v-model="visible" :isEdit="isEdit" :params="waitItem" :platformList="platformList" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import { columnsArticle, searchForm } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import AddArticle from './components/AddArticle'
import api from '@/api/'
import store from '@/store/'

const label = {
  label: '标签同步',
  article: '文章同步'
}
export default {
  components: { AddArticle },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    const state = reactive({
      label: label.label,
      searchForm: { ...searchForm },
      columnsArticle,
      times: [],
      // tabName: '第图',
      tabName: _this.$route.query.name,
      platformList: []
    })

    onMounted(async () => {
      await methods.getPlatform()
      methods.getList()
      state.label = parseInt(_this.$route.query.category) === 1 ? label.article : label.label
    })
    const labelList = computed(() => {
      const list = store.state.label.data.WEBSITE?.WEBSITE_MAP_CHANGE_FREQ
      return text => {
        return list?.find(item => {
          return item.key === text
        })?.value
      }
    })
    const categoryText = computed(() => {
      const list = store.state.label.data.WEBSITE?.WEBSITE_MAP_CATEGORY
      return text => {
        return list?.find(item => {
          return item.key === text
        })?.value
      }
    })
    const methods = {
      async search() {
        const res = await api.mapArticleSync({
          website_map_id: _this.$route.query.website_map_id
        })
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
          methods.getList()
        }
      },

      async getList() {
        _this.loading = true
        const res = await api.websiteMapDetailList({
          ..._this.searchForm,
          website_map_id: _this.$route.query.website_map_id,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { websiteMapDetails, pagination } = res.data
        _this.data = websiteMapDetails
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },

      async inputDebounce(sort, data) {
        const res = await api.updateLink(data)
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
        }
      },
      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },
      async del(data) {
        this.$confirm({
          title: '是否确定删除？',
          okText: '确认',
          cancelText: '取消',
          onOk: async () => {
            const res = await api.websiteMapDetailDelete({ id: data.id })
            if (_this.$validate(res)) {
              _this.$message.success('删除成功~')
              _this.getList()
            }
          }
        })
      },
      async handleClear() {
        const res = await api.mapDetailSyncXml({
          website_map_id: _this.$route.query.website_map_id
        })
        if (_this.$validate(res)) {
          _this.$message.success('同步成功')
          _this.getList()
        }
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
      // 查看文章
      lookArticle(item) {
        _this.$router.push('/websiteAdmin/lookArticle')
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...methods,
      labelList,
      categoryText
    }
  }
}
</script>
